import type { SiteRegion } from "@safers/api";

export const REGION_DISPLAY_NAMES: Record<SiteRegion, string> = {
  SEOUL: "서울",
  GYEONGGI_INCHEON: "경기인천",
  GANGWON: "강원도",
  CHUNGCHEONG: "충청도",
  JEOLLA: "전라도",
  GYEONGSANG: "경상도",
  JEJU: "제주도",
};
